var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComparisonTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H6.58824C7.41666 0.5 8.08824 1.17157 8.08824 2V16C8.08824 16.8284 7.41666 17.5 6.58824 17.5H2C1.17157 17.5 0.5 16.8284 0.5 16V2ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V16C1.5 16.2761 1.72386 16.5 2 16.5H6.58824C6.86438 16.5 7.08824 16.2761 7.08824 16V2C7.08824 1.72386 6.86438 1.5 6.58824 1.5H2ZM10.3824 6.70588C10.3824 5.87745 11.0539 5.20588 11.8824 5.20588H16C16.8284 5.20588 17.5 5.87746 17.5 6.70588V16C17.5 16.8284 16.8284 17.5 16 17.5H11.8824C11.0539 17.5 10.3824 16.8284 10.3824 16V6.70588ZM11.8824 6.20588C11.6062 6.20588 11.3824 6.42974 11.3824 6.70588V16C11.3824 16.2761 11.6062 16.5 11.8824 16.5H16C16.2761 16.5 16.5 16.2761 16.5 16V6.70588C16.5 6.42974 16.2761 6.20588 16 6.20588H11.8824Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTheme);
export default __webpack_public_path__ + "static/media/comparison-theme.b64708d865e51d9ddf2f11be341791cb.svg";
export { ForwardRef as ReactComponent };